"use client"

import { Skeleton } from "@/components/ui/skeleton"

export default function BookingSuccessSkeleton() {
  return (
    <div className="w-full flex justify-center py-10 px-4">
      <div className="w-full max-w-md bg-white rounded-2xl p-6 shadow-sm border border-gray-100 space-y-4">
        <div className="flex justify-center">
          <Skeleton className="h-5 w-32" />
        </div>
        <Skeleton className="h-5 w-24" />
        <Skeleton className="h-12 w-full rounded-xl" />
        <Skeleton className="h-12 w-full rounded-xl" />
        <Skeleton className="h-12 w-full rounded-xl" />
        <div className="flex justify-center">
<Skeleton className="w-48 h-48" />        </div>
        <div className="flex gap-3">
          <Skeleton className="h-11 flex-1 rounded-full" />
          <Skeleton className="h-11 flex-1 rounded-full" />
        </div>
      </div>
    </div>
  )
}
